// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd954327","239":"e39fb35b","295":"26d4cf91","455":"1e2a2f6a","793":"0bacce19"}[chunkId] + ".chunk.js";
};